export default "__VITE_ASSET__e62f4273__"